import React, { FC, useState, Fragment } from 'react';

import { FlexRowSpaceEvenly, PageTitle } from '../common-styles/common-styles';
import { Hole } from './course-hole';
import * as CSS from './course-styles';
import { UpdateButton } from './update-button';
import { Course } from '../../../database.schema';

const outHoles = [1, 2, 3, 4, 5, 6, 7, 8, 9];
const inHoles = [10, 11, 12, 13, 14, 15, 16, 17, 18];

const scoreCardValid = (scoreCard: Array<number>): boolean => {
  return scoreCard.some((par: number) => par === 3) && scoreCard.some((par: number) => par === 4) && scoreCard.some((par: number) => par === 5);
};
const strokeIndexesAreValid = (strokeIndexes: Array<number>): boolean => {
  const strokeIndexSet = new Set<number>(strokeIndexes);
  if (strokeIndexSet.size === 18) {
    return true;
  }
  return false;
};
type CourseEntryProps = {
  courseIndex: number;
  course: Course;
  resetDataEntry: (value: boolean) => void;
};
export const CourseEntry: FC<CourseEntryProps> = ({ courseIndex, course, resetDataEntry }) => {
  const [isDataValid, setIsDataValid] = useState<boolean>(false);
  const [courseClone, setCourseClone] = useState<Course>(course);
  const [updateStatus, setUpdateStatus] = useState({ success: false, error: false });
  const [courseOutTotal, setCourseOutTotal] = useState<number>(
    courseClone.scoreCard.reduce((accumulator, currentValue, cIindex) => (cIindex < 9 ? accumulator + currentValue : accumulator)),
  );
  const [courseInTotal, setCourseInTotal] = useState<number>(courseClone.scoreCard.reduce((accumulator, currentValue, cIindex) => (cIindex > 8 ? accumulator + currentValue : 0)));
  const setCoursePar = (index: number, value: number): void => {
    const cloneCoursePars = [...courseClone.scoreCard];
    cloneCoursePars[index] = value;
    setCourseClone({ ...courseClone, scoreCard: cloneCoursePars });
    setCourseOutTotal(cloneCoursePars.reduce((accumulator, currentValue, cIindex) => (cIindex < 9 ? accumulator + currentValue : accumulator)));
    setCourseInTotal(cloneCoursePars.reduce((accumulator, currentValue, cIindex) => (cIindex > 8 ? accumulator + currentValue : 0)));
    validateData(courseClone.strokeIndex, cloneCoursePars);
  };
  const setCourseStrokeIndex = (index: number, value: number) => {
    const cloneCourseStrokeIndexes = [...courseClone.strokeIndex];
    cloneCourseStrokeIndexes[index] = value;
    setCourseClone({ ...courseClone, strokeIndex: cloneCourseStrokeIndexes });
    validateData(cloneCourseStrokeIndexes, courseClone.scoreCard);
  };
  const validateData = (strokeIndex: number[], scorecard: number[]) => {
    if (strokeIndexesAreValid(strokeIndex) && scoreCardValid(scorecard)) {
      setIsDataValid(true);
    } else {
      setIsDataValid(false);
    }
  };
  return (
    <Fragment>
      <PageTitle>
        <h2>Course Details</h2>
      </PageTitle>
      {updateStatus.success && <CSS.ErrorMessage>Update Success!!!!</CSS.ErrorMessage>}
      {updateStatus.error && <CSS.ErrorMessage>Update failed!!!!</CSS.ErrorMessage>}
      <form onSubmit={(event) => event.preventDefault()}>
        <CSS.NameWrapper>
          <div>Name</div>
          <input
            type="text"
            name="courseName"
            id="course-name"
            data-testid="course-name"
            value={courseClone.name}
            onChange={(e) => {
              setCourseClone({ ...courseClone, name: e.target.value });
              validateData(courseClone.strokeIndex, courseClone.scoreCard);
            }}
          />
        </CSS.NameWrapper>
        <CSS.FlexRow>
          <CSS.HoleNumberTitle>Hole</CSS.HoleNumberTitle>
          <CSS.HoleParTitle>Par</CSS.HoleParTitle>
          <CSS.HoleSITitle>SI</CSS.HoleSITitle>
        </CSS.FlexRow>
        {outHoles.map((holeNumber: number, index: number) => {
          return (
            <Hole
              key={`out-hole-${index}`}
              holeIndex={index}
              holeNumber={holeNumber}
              holePar={courseClone.scoreCard[index]}
              holeStrokeIndex={courseClone.strokeIndex[index]}
              setCoursePar={setCoursePar}
              setCourseSi={setCourseStrokeIndex}
            />
          );
        })}
        <CSS.TotalWrapper>
          <CSS.TotalText>Out</CSS.TotalText>
          <CSS.Total>{courseOutTotal}</CSS.Total>
        </CSS.TotalWrapper>
        {inHoles.map((holeNumber: number, index: number) => {
          return (
            <Hole
              key={`in-hole-${index}`}
              holeIndex={index + 9}
              holeNumber={holeNumber}
              holePar={courseClone.scoreCard[index + 9]}
              holeStrokeIndex={courseClone.strokeIndex[index + 9]}
              setCoursePar={setCoursePar}
              setCourseSi={setCourseStrokeIndex}
            />
          );
        })}
        <CSS.TotalWrapper>
          <CSS.TotalText>In</CSS.TotalText>
          <CSS.Total>{courseInTotal}</CSS.Total>
        </CSS.TotalWrapper>
        <CSS.TotalWrapper>
          <CSS.TotalText>Total</CSS.TotalText>
          <CSS.Total>{courseOutTotal + courseInTotal}</CSS.Total>
        </CSS.TotalWrapper>
      </form>
      <CSS.ButtonWrapper>
        <UpdateButton course={courseClone} courseIndex={courseIndex} setUpdateStatus={setUpdateStatus} setShowUpdate={resetDataEntry} isDisabled={!isDataValid} />
        <CSS.Button
          onClick={() => {
            resetDataEntry(false);
          }}
        >
          Cancel
        </CSS.Button>
      </CSS.ButtonWrapper>
    </Fragment>
  );
};
